import { Redirect, useLocation } from 'react-router-dom';

import passwordUpdateCourier from '@/shared/auth/helpers/passwordUpdateCourier';
import { authorized, getAuthAccount, getAuthUser } from '@/shared/auth/selectors';
import { isMobile } from '@/shared/util/device';
import { useWiwSelector } from '@/store';

import moment from 'moment-timezone';

export default function RedirectParameterHandler() {
  const location = useLocation();
  const isAuthed = useWiwSelector(authorized);
  const user = useWiwSelector(getAuthUser);
  const account = useWiwSelector(getAuthAccount);
  const query = new URLSearchParams(location.search);

  // Check if this is a fresh mobile signup that should be redirected to mobile finish setup
  if (isAuthed && user && account) {
    const isOnMobileDevice = isMobile();
    const isRecentAccount = account && moment().diff(account.date('created_at'), 'days') <= 1;
    const justSetPassword = passwordUpdateCourier.passwordChangeSuccessful(false);
    const isManager = user.canManage();

    // If this is a mobile manager who just signed up, redirect to mobile finish setup
    // Only redirect if not already on the mobile finish setup page
    if (
      isOnMobileDevice &&
      isRecentAccount &&
      justSetPassword &&
      isManager &&
      location.pathname !== '/onboarding/mobile-finish-setup'
    ) {
      passwordUpdateCourier.passwordChangeSuccessful(true); // Clear the cookie
      return <Redirect to="/onboarding/mobile-finish-setup?mobile=1" />;
    }
  }

  // Handle explicit redirect parameter
  if (isAuthed && query.has('redirect')) {
    const redirectTo = query.get('redirect');
    return <Redirect to={redirectTo} />;
  }

  return null;
}
